import styled from '@emotion/styled';
import type { FC } from 'react';

import { Progress } from '../../Progress';
import Typography from '../../Typography';
import type { ProgressCellProps } from '../types';

const ProgressCellRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  width: '100%',
  minWidth: 0,
});

const ProgressValue = styled(Typography)(({ theme }) => ({
  color: theme.colors.white[80],
  whiteSpace: 'nowrap',
  flexShrink: 0,
}));

export const ProgressCell: FC<ProgressCellProps> = ({ value, min = 0, max = 100 }) => {
  const percentage = ((value - min) / (max - min)) * 100;
  const displayValue = `${Math.round(percentage)}%`;

  return (
    <ProgressCellRoot>
      <Progress value={percentage} />
      <ProgressValue variant="body3">{displayValue}</ProgressValue>
    </ProgressCellRoot>
  );
};

ProgressCell.displayName = 'ProgressCell';
